export enum SortBy {
  DISTANCE = 'distance',
  LOWEST_PRICE = 'sort_price=asc',
  HIGHEST_PRICE = 'sort_price=desc',
  NEWLY_ADDED = 'sort_added=asc',
  LOWEST_MILEAGE = 'sort_mileage=asc',
  HIGHEST_MILEAGE = 'sort_mileage=desc',
};
